import { Image, transition } from '@hover/blueprint';
import type { FlexProps } from '@hover/blueprint/chakra';
import { Flex } from '@hover/blueprint/chakra';
import React from 'react';

interface VariationColoredTextureProps extends FlexProps {
  thumbnail: string;
  color?: string;
  isSelected: boolean;
  disableHover?: boolean;
}

export const VariationColoredTexture = ({
  thumbnail,
  color,
  isSelected,
  disableHover,
  ...props
}: VariationColoredTextureProps) => {
  const hoverProps = disableHover
    ? {}
    : {
        outlineColor: isSelected ? undefined : 'darkAlpha.500',
      };
  return (
    <Flex
      _hover={hoverProps}
      as="button"
      backgroundColor={color ?? 'neutral.0'}
      border="none"
      borderRadius={300}
      cursor="pointer"
      flexDirection="column"
      height="100%"
      outlineColor={isSelected ? 'neutral.900' : 'transparent'}
      outlineOffset="4px"
      p={0}
      position="relative"
      sx={{
        outlineStyle: 'solid',
        outlineWidth: '3px',
      }}
      width="100%"
      {...transition.easing250('outline-color')}
      {...props}
    >
      <Image
        alt=""
        borderRadius="inherit"
        display="block"
        height="100%"
        mixBlendMode={thumbnail ? 'multiply' : undefined}
        src={thumbnail ?? undefined}
        width="100%"
      />
    </Flex>
  );
};
